// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCcUbglvaO1xOCkqJEKWrnFsa789rQq5sc",
  authDomain: "alifetokentest.firebaseapp.com",
  projectId: "alifetokentest",
  storageBucket: "alifetokentest.appspot.com",
  messagingSenderId: "34583743795",
  appId: "1:34583743795:web:4af57ad9747698f9130246",
  measurementId: "G-ELJELMLQJS"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
export default db;



// WEBPACK FOOTER //
// ./src/firebase.js